export const consultingData: string[] = ['SPO', 'MND', 'HDAC', 'MEDIBLOC'];
